import React, { useState, useEffect } from 'react'
import { PostData } from '../Services/httpHandelars';
import Snackbar from '../Components/Snackbar'

export default function ForgetPassword() {


  const [form, setForm] = useState({resetEmail:""}) 
  const [snacBar, setSnacBar ] =useState({snacStatus: false, message:"", snackType:""})

  const handleChange = (event) => {
    setForm({ ...form, [event.target.name]: event.target.value });
    console.log(form);
  };

  const submitHandler = (e) => {
    e.preventDefault();
    if(form.resetEmail){

      PostData("/api/sendResetEmail", form).then((success)=>{
        if(success.status === true){
          setSnacBar({...snacBar, 
            snacStatus: success.status,
            message:success.message,
            snackType:"Success"
          })
        }else{
          setSnacBar({...snacBar, 
            snacStatus: true,
            message:  success.message,
            snackType:"Error"
          })
        }
      })

    }else{
      setSnacBar({...snacBar, 
        snacStatus: true,
        message: "Please Enter Email",
        snackType:"warning"
      })
    }
   
    
  }

  useEffect(
    () => {
        if (snacBar.snacStatus === true) {
            setTimeout(() => setSnacBar(false), 3000);
        }
    },

    [snacBar.snacStatus]
);

  

  return (
    <>
    <div class="flex justify-center item-center mt-32">
  <div class="block p-6 rounded-lg shadow-lg bg-white w-1/5">
    <h5 class="text-gray-900 text-xl leading-tight font-medium mb-2 text-center">Forgot Password?</h5>
    <div class="mb-4 mt-8">
        <p>
            Please enter the email address associated with your account and We will email you a link to reset your password.
        </p>
      <label class="block text-gray-700 text-sm font-bold mb-2 mt-8" for="username">
        Enter your E-mail 
      </label>
      <input onChange={handleChange} name="resetEmail" value={form.resetEmail} class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" id="resetEmail" type="text" placeholder="E-mail" />
    </div>

    <div className='flex flex-row justify-between mt-8'>
        <button type="button" onClick={submitHandler} class=" inline-block px-6 py-2.5 bg-green-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-green-700 hover:shadow-lg focus:bg-green-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-green-800 active:shadow-lg transition duration-150 ease-in-out">Send Mail</button>
        <a href="/Login" className='text-blue-500'>Back to login</a>
    </div>
  
  </div>
</div>
         {snacBar?.snacStatus &&
          <Snackbar snackType={snacBar?.snackType} message={snacBar.message} status={snacBar?.snacStatus} setSnacBar={setSnacBar}/>
      }
 </>
  )
}
